module.exports = __webpack_public_path__ + "static/media/bgairtime.91ada643.svg";